export default {
    init() {
        this.lotsListTagsToggle();
        this.lotsLogToggle();
        this.checkAllLotsToggle();
        this.packedListOrder();
        this.editLotsRowPriceOrQtyPopUp();
        this.popUpInputValue();
        this.createPack();
        this.removeItemFromPack();
        this.unpackAction();
        this.toggleLotsSidebar();
        this.lotsSidebarDynamicColumnToggle();
        this.sidebarRemoveSingleItem();
        this.sidebarRemoveAllItems();
        this.lotsListAddSelected();
        this.quickView();
        },



    lotsListTagsToggle() {
        let tags = $('.lots-list--helpers--tag');

        tags.on('click', function (e) {
            e.preventDefault();
            tags.removeClass('active');
            $(this).addClass('active');
        });
    },
    lotsLogToggle(selector) {
        let itemToClick = $('.lots-list--item-row--info-wrap');
        if (selector) {
            itemToClick = selector;
        }

        itemToClick.on('click', function () {
            let row = $(this).parents().eq(2);
            let logList = row.find('.lots-list--item-row--log-hidden');
            if (logList.length > 0) {
                $('.lots-list--item-row--log-hidden').slideUp(300);
                logList.stop().slideToggle(300);
            }
        });
    },

    checkAllLotsToggle() {
        $('.check-all').on('change', function () {
            let lotsListItem = $('.secondary-table--body--item');

            if ($(this).is(':checked')) {
                lotsListItem.each(function (i, val) {
                    $(val).find('.lots-item-checkbox').prop('checked', true);
                });
            } else {
                lotsListItem.each(function (i, val) {
                    $(val).find('.lots-item-checkbox').prop('checked', false);
                });
            }
        });
    },

    packedListOrder() {
        $('body').on('click', function (e) {
            if ($(e.target).hasClass('order-arrow')) {
                let thisList = $(e.target).parents().eq(3);
                let thisItem = $(e.target).parents().eq(2);
                let thisItemIndex = parseInt(thisItem.attr('data-order'));
                let itemsOfThisList = thisList.find('.lots-list--item-row');
                let wholePack = $(e.target).parents().eq(6);

                if ($(e.target).hasClass('up') && thisItemIndex !== 0) {
                    itemsOfThisList.each(function (i, val) {
                        let itemOrderNumber = parseInt($(val).attr('data-order'));

                        if (itemOrderNumber === thisItemIndex) {
                            $(val)
                                .css('order', thisItemIndex - 1)
                                .attr('data-order', thisItemIndex - 1);
                        } else if (itemOrderNumber === thisItemIndex - 1) {
                            $(val)
                                .css('order', itemOrderNumber + 1)
                                .attr('data-order', itemOrderNumber + 1);
                        } else if (itemOrderNumber !== thisItemIndex) {
                            $(val)
                                .css('order', itemOrderNumber)
                                .attr('data-order', itemOrderNumber);
                        }
                    });

                    let topItem = thisList.find('.lots-list--item-row[data-order="0"]');
                    let topImg = topItem.find('.image-holder img').attr('src');
                    wholePack.find('.image-holder img').first().attr('src', topImg);
                } else if ($(e.target).hasClass('down') && thisItemIndex +1 !== itemsOfThisList.length) {
                    itemsOfThisList.each(function (i, val) {
                        let itemOrderNumber = parseInt($(val).attr('data-order'));

                        if (itemOrderNumber === thisItemIndex) {
                            $(val)
                                .css('order', thisItemIndex + 1)
                                .attr('data-order', thisItemIndex + 1);
                        } else if (itemOrderNumber === thisItemIndex + 1) {
                            $(val)
                                .css('order', itemOrderNumber - 1)
                                .attr('data-order', itemOrderNumber - 1);
                        } else if (itemOrderNumber !== thisItemIndex) {
                            $(val)
                                .css('order', itemOrderNumber)
                                .attr('data-order', itemOrderNumber);
                        }
                    });

                    let topItem = thisList.find('.lots-list--item-row[data-order="0"]');
                    let topImg = topItem.find('.image-holder img').attr('src');
                    wholePack.find('.image-holder img').first().attr('src', topImg);
                }
            }
        });
    },


    editLotsRowPriceOrQtyPopUp() {
        let popUp = $('.edit-lots-popup');
        let originalAmount = 0;
        let itemClicked = null;
        const self = this;

        $('body').on('click', function (e) {
            if ($(e.target).hasClass('edit-item')) {
                e.preventDefault();

                $('.popup-input').val($(e.target).attr('data-amount'));
                originalAmount = $(e.target).attr('data-amount');
                itemClicked = $(e.target);
                popUp.fadeIn(300);
                if ($(e.target).parents().eq(1).hasClass('quantity')) {
                    $('.edit-lots-popup .qty').show();
                    $('.edit-lots-popup .reg').hide();
                } else {
                    $('.edit-lots-popup .qty').hide();
                    $('.edit-lots-popup .reg').show();
                }
            }
        });

        $('body').on('mousedown', function (e) {
            if ($(e.target).hasClass('edit-lots-popup')) {
                popUp.fadeOut(300);
            }
        });

        $('.edit-lots-popup .close-pop').on('click', function (e) {
            e.preventDefault();
            popUp.fadeOut(300);
        });

        $('.edit-lots-popup .confirm').on('click', function (e) {
            e.preventDefault();
            let popUpVal = $('.popup-input').val();

            if (popUpVal !== originalAmount) {
                itemClicked.attr('data-amount', popUpVal);
                itemClicked.parent().find('.amount').html(popUpVal);
                if (itemClicked.parents().eq(4).hasClass('lots-list--item-row--log-list')) {
                    self.updatePackAfterChange(itemClicked.parents().eq(7));
                }
            }
            popUp.fadeOut(300);
        });
    },
    popUpInputValue() {
        $('.popup-input').on('change keyup', function () {
            if ($(this).val() < 0) {
                $(this).val(1);
            }
        });
    },


    createPack() {
        const self = this;
        let popUp = $('.create-pack-popup');

        $('.template-add-lots .pack-selected').on('click', function (e) {
            e.preventDefault();

            if ($('.lots-item-checkbox:checked').length > 1) {
                let details = packInfo();
                if (details.packCount === 1 && details.regularCount >= 1) {
                    self.addToExistingPack();
                } else {
                    popUp.fadeIn(300);
                }
            }
        });

        function packInfo() {
            let packCount = 0;
            let regularCount = 0;
            let result = [];
            $('.lots-item-checkbox:checked').each(function (i, val) {
                if ($(val).parents().eq(3).hasClass('pack-item')) {
                    packCount++;
                } else {
                    regularCount++;
                }
            });

            result['packCount'] = packCount;
            result['regularCount'] = regularCount;
            return result;
        }

        $('body').on('mousedown', function (e) {
            if ($(e.target).hasClass('create-pack-popup')) {
                popUp.fadeOut(300);
                $('.pack-name-input').val('');
            }
        });

        $('.create-pack-popup .close-pop').on('click', function (e) {
            e.preventDefault();
            popUp.fadeOut(300);
            $('.pack-name-input').val('');
        });

        $('.create-pack-popup .confirm').on('click', function (e) {
            e.preventDefault();
            let packName = $('.pack-name-input');

            if (packName.val() !== '') {
                self.configurePack(packName.val(), packInfo());
                popUp.fadeOut(300);
                packName.val('');
            }
        });
    },
    configurePack(packName, packInfo) {
        const self = this;

        let template = `
       <tr class="secondary-table--body--item semi p-lg package-lot">
                        <td class="column column-check">
                            <label class="form-checkbox">
                                <input type="checkbox" class="lots-item-checkbox" name="">
                                <span class="custom-checkmark"></span>
                            </label>
                        </td>
                        <td class="column">
                            <div class="package--info-wrap">
                                <div class="image-wrap">
                                    <div class="image-holder">
                                        <img src="src/images/car1.png" alt="">
                                        <div class="package-count">+2</div>
                                    </div>
                                </div>
                                <div class="content-wrap">
                                    <div class="title-row">
                                        Pack: <strong>${packName}</strong>
                                    </div>
                                    <div class="information-list">
                                        <div class="item-row">Lots: <strong>3</strong></div>
                                        <div class="item-row">ID: 12349234</div>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td class="column">
                            <div class="price price-warning">
                                <icon></icon>
                                <div class="currency">€</div>
                                <div class="amount">12 400.00</div>
                            </div>
                        </td>
                        <td class="column">
                            <div class="price">
                                <icon></icon>
                                <div class="currency">€</div>
                                <div class="amount">12 400.00</div>
                            </div>
                        </td>
                        <td class="column">
                            <div class="price">
                                <icon></icon>
                                <div class="currency">€</div>
                                <div class="amount">12 400.00</div>
                            </div>
                        </td>
                        <td class="column">
                            <div class="price price-error">
                                <icon></icon>
                                <div class="currency">€</div>
                                <div class="amount">12 400.00</div>
                            </div>
                        </td>
                        <td class="column actions">
                            <div class="actions-list">
                                <a href="" class="grey-button pb-sm min-w-auto me-2">UNPACK</a>
                                <a href="" class="grey-button pb-sm min-w-auto add-lot-action">ADD</a>
                            </div>
                        </td>
                    </tr>
        `;

        let orderDiv = `
            <div class="order">
                <i class="up order-arrow"></i>
                <i class="down order-arrow"></i>
            </div>
        `;

        $('.add-lots-auction-step2-list').append(template);
        let counter = 0;
        let imgSrc = '';
        let qtyCount = 0;
        let minPriceCount = 0;
        let targetPriceCount = 0;
        let buyNowCount = 0;
        let aiPriceCount = 0;
        let newPack = $('.add-lots-auction-step2-list .pack-item').last();

        $('.lots-list--body .lots-item-checkbox:checked').each(function (i, val) {
            if ($(val).parents().eq(3).hasClass('pack-item')) {
                let packListItems = $(val).parents().eq(3).find('.lots-list--item-row--log-list .lots-list--item-row');

                packListItems.each(function (index, value) {
                    let clone = $(value).clone();
                    clone.attr('data-order', counter);
                    if (counter === 0) {
                        imgSrc = clone.find('.image-holder img').attr('src');
                    }
                    counter++;
                    let itemQty = parseInt(clone.find('.lots-list--item-row--column.quantity .edit-item').attr('data-amount'));
                    qtyCount+= itemQty;
                    let itemMinPrice = parseFloat(clone.find('.lots-list--item-row--column.min-price .edit-item').attr('data-amount'));
                    minPriceCount+= itemMinPrice;
                    let itemTargetPrice = parseFloat(clone.find('.lots-list--item-row--column.target-price .edit-item').attr('data-amount'));
                    targetPriceCount+= itemTargetPrice;
                    let itemBuyNow = parseFloat(clone.find('.lots-list--item-row--column.buy-now .edit-item').attr('data-amount'));
                    buyNowCount+= itemBuyNow;
                    let aiPrice = clone.find('.lots-list--item-row--column.ai-price .amount').html();
                    let itemAiPrice = parseFloat( aiPrice.split(' ').join('') );
                    aiPriceCount+= itemAiPrice;
                    newPack.find('.image-holder img').first().attr('src', imgSrc);
                    newPack.find('.lots-list--item-row--log-list').append(clone);
                    newPack.find('.lots-list--item-row--log-list .lots-item-checkbox').prop('checked', false);
                });

                $(val).parents().eq(3).remove();
            } else {
                let clone = $(val).parents().eq(3).clone();
                $(val).parents().eq(3).hide(); //.addClass('hidden');
                $(val).parents().eq(3).find('.lots-item-checkbox').prop('checked', false);
                clone.find('.lots-list--item-row--main').append(orderDiv);
                clone.attr('data-order', counter);
                if (counter === 0) {
                    imgSrc = clone.find('.image-holder img').attr('src');
                    newPack.find('.image-holder img').first().attr('src', imgSrc);
                }
                counter++;
                let cloneLogList = clone.find('.lots-list--item-row--log-hidden');
                if (cloneLogList.length > 0) {
                    cloneLogList.remove();
                }
                let itemQty = parseInt(clone.find('.lots-list--item-row--column.quantity .edit-item').attr('data-amount'));
                qtyCount+= itemQty;
                let itemMinPrice = parseFloat(clone.find('.lots-list--item-row--column.min-price .edit-item').attr('data-amount'));
                minPriceCount+= itemMinPrice;
                let itemTargetPrice = parseFloat(clone.find('.lots-list--item-row--column.target-price .edit-item').attr('data-amount'));
                targetPriceCount+= itemTargetPrice;
                let itemBuyNow = parseFloat(clone.find('.lots-list--item-row--column.buy-now .edit-item').attr('data-amount'));
                buyNowCount+= itemBuyNow;
                let aiPrice = clone.find('.lots-list--item-row--column.ai-price .amount').html();
                let itemAiPrice = parseFloat( aiPrice.split(' ').join('') );
                aiPriceCount+= itemAiPrice;
                newPack.find('.lots-list--item-row--log-list').append(clone);
                newPack.find('.lots-list--item-row--log-list .lots-item-checkbox').prop('checked', false);
            }
        });

        let data = [];
        data['qty'] = qtyCount;
        data['minPrice'] = minPriceCount;
        data['targetPrice'] = targetPriceCount;
        data['buyNow'] = buyNowCount;
        data['aiPrice'] = aiPriceCount;
        self.updateNewPack(data);
    },
    updateNewPack(data) {
        const self = this;

        let lastPack = $('.lots-list .lots-list--item-row.pack-item').last();
        let lastPackItems = lastPack.find('.lots-list--item-row--log-list .lots-list--item-row');
        lastPack.find('.image-wrap .count').html('+' + lastPackItems.length);
        lastPack.find('.lots-count').html('Lots: <span>' + lastPackItems.length + '</span>');
        lastPack.find('.lots-list--item-row--column.quantity .edit-item').first().attr('data-amount', data.qty);
        lastPack.find('.lots-list--item-row--column.quantity .amount').first().html(data.qty);
        lastPack.find('.lots-list--item-row--column.min-price .edit-item').first().attr('data-amount', data.minPrice);
        lastPack.find('.lots-list--item-row--column.min-price .amount').first().html(data.minPrice);
        lastPack.find('.lots-list--item-row--column.target-price .edit-item').first().attr('data-amount', data.targetPrice);
        lastPack.find('.lots-list--item-row--column.target-price .amount').first().html(data.targetPrice);
        lastPack.find('.lots-list--item-row--column.buy-now .edit-item').first().attr('data-amount', data.buyNow);
        lastPack.find('.lots-list--item-row--column.buy-now .amount').first().html(data.buyNow);
        lastPack.find('.lots-list--item-row--column.ai-price .amount').first().html(data.aiPrice);

        self.lotsLogToggle(lastPack.find('.lots-list--item-row--info-wrap').first());
        self.resetCheckboxes();
    },
    removeItemFromPack() {
        const self = this;

        $('body').on('click', function (e) {
            if ($(e.target).hasClass('remove-from-pack')) {
                e.preventDefault();

                let item = $(e.target).parents().eq(3);
                let itemId = item.find('.lots-item-checkbox').val();
                let itemCount = $(e.target).parents().eq(4).find('.lots-list--item-row').length;
                let packItems = $(e.target).parents().eq(4).find('.lots-list--item-row');
                let wholePack = $(e.target).parents().eq(7);

                if (itemCount >= 3) {
                    $('.lots-list .lots-list--item-row:not(.pack-item)').each(function (i, val) {
                        if (!$(val).parent().hasClass('lots-list--item-row--log-list')) {
                            if ($(val).find('.lots-item-checkbox').val() === itemId) {
                                $(val).show();
                                item.remove();
                            }
                        }
                    });
                    self.updatePackAfterChange(wholePack);
                } else {
                    let packIds = [];
                    packItems.each(function (i, val) {
                        packIds.push($(val).find('.lots-item-checkbox').val());
                    });

                    $('.lots-list .lots-list--item-row:not(.pack-item)').each(function (i, val) {
                        if (!$(val).parent().hasClass('lots-list--item-row--log-list')) {
                            let rowId = $(val).find('.lots-item-checkbox').val();
                            if (packIds.includes(rowId)) {
                                $(val).show();
                            }
                        }
                    });

                    if (item.find('.dynamic-column').length > 0) {
                        let cartCount = $('.lots-sidebar--heading .added span');
                        cartCount.html( parseInt(cartCount.html()) - 1 );
                    }

                    wholePack.remove();
                }
            }
        });
    },
    unpackAction() {
        $('body').on('click', function (e) {
            if ($(e.target).hasClass('unpack-action')) {
                e.preventDefault();

                let wholePack = $(e.target).parents().eq(3);
                let packItems = wholePack.find('.lots-list--item-row--log-list .lots-list--item-row');

                let packIds = [];
                packItems.each(function (i, val) {
                    packIds.push($(val).find('.lots-item-checkbox').val());
                });

                $('.lots-list .lots-list--item-row:not(.pack-item)').each(function (i, val) {
                    if (!$(val).parent().hasClass('lots-list--item-row--log-list')) {
                        let rowId = $(val).find('.lots-item-checkbox').val();
                        if (packIds.includes(rowId)) {
                            $(val).show();
                        }
                    }
                });
                wholePack.remove();
            }
        });
    },
    updatePackAfterChange(pack) {
        const self = this;
        let counter = 0;
        let imgSrc = '';
        let qtyCount = 0;
        let minPriceCount = 0;
        let targetPriceCount = 0;
        let buyNowCount = 0;
        let aiPriceCount = 0;

        pack.find('.lots-list--item-row--log-list .lots-list--item-row').each(function (i, val) {
            $(val).attr('data-order', counter);
            if (counter === 0) {
                imgSrc = $(val).find('.image-holder img').attr('src');
            }
            counter++;
            let itemQty = parseInt($(val).find('.lots-list--item-row--column.quantity .edit-item').attr('data-amount'));
            qtyCount+= itemQty;
            let itemMinPrice = parseFloat($(val).find('.lots-list--item-row--column.min-price .edit-item').attr('data-amount'));
            minPriceCount+= itemMinPrice;
            let itemTargetPrice = parseFloat($(val).find('.lots-list--item-row--column.target-price .edit-item').attr('data-amount'));
            targetPriceCount+= itemTargetPrice;
            let itemBuyNow = parseFloat($(val).find('.lots-list--item-row--column.buy-now .edit-item').attr('data-amount'));
            buyNowCount+= itemBuyNow;
            let aiPrice = $(val).find('.lots-list--item-row--column.ai-price .amount').html();
            let itemAiPrice = parseFloat( aiPrice.split(' ').join('') );
            aiPriceCount+= itemAiPrice;
        });

        pack.find('.image-holder img').first().attr('src', imgSrc);

        let data = [];
        data['qty'] = qtyCount;
        data['minPrice'] = minPriceCount;
        data['targetPrice'] = targetPriceCount;
        data['buyNow'] = buyNowCount;
        data['aiPrice'] = aiPriceCount;
        self.updateOldPackInfo(data, pack);
    },
    updateOldPackInfo(data, pack) {
        const self = this;

        let lastPackItems = pack.find('.lots-list--item-row--log-list .lots-list--item-row');
        pack.find('.image-wrap .count').html('+' + lastPackItems.length);
        pack.find('.lots-count').html('Lots: <span>' + lastPackItems.length + '</span>');
        pack.find('.lots-list--item-row--column.quantity .edit-item').first().attr('data-amount', data.qty);
        pack.find('.lots-list--item-row--column.quantity .amount').first().html(data.qty);
        pack.find('.lots-list--item-row--column.min-price .edit-item').first().attr('data-amount', data.minPrice);
        pack.find('.lots-list--item-row--column.min-price .amount').first().html(data.minPrice);
        pack.find('.lots-list--item-row--column.target-price .edit-item').first().attr('data-amount', data.targetPrice);
        pack.find('.lots-list--item-row--column.target-price .amount').first().html(data.targetPrice);
        pack.find('.lots-list--item-row--column.buy-now .edit-item').first().attr('data-amount', data.buyNow);
        pack.find('.lots-list--item-row--column.buy-now .amount').first().html(data.buyNow);
        pack.find('.lots-list--item-row--column.ai-price .amount').first().html(data.aiPrice);

        self.resetCheckboxes();
    },
    addToExistingPack() {
        const self = this;
        let packItem = null;
        let qtyCount = 0;
        let minPriceCount = 0;
        let targetPriceCount = 0;
        let buyNowCount = 0;
        let aiPriceCount = 0;
        let orderDiv = `
            <div class="order">
                <i class="up order-arrow"></i>
                <i class="down order-arrow"></i>
            </div>
        `;
        let checkedItems = $('.lots-item-checkbox:checked');

        checkedItems.each(function (i, val) {
            if ($(val).parents().eq(3).hasClass('pack-item')) {
                packItem = $(val).parents().eq(3);
            }
        });

        let packItems = packItem.find('.lots-list--item-row--log-list .lots-list--item-row');
        let countAppended = 0;

        checkedItems.each(function (i, val) {
            if (!$(val).parents().eq(3).hasClass('pack-item')) {
                let clone = $(val).parents().eq(3).clone();
                $(val).parents().eq(3).hide();
                $(val).parents().eq(3).find('.lots-item-checkbox').prop('checked', false);
                clone.find('.lots-list--item-row--main').append(orderDiv);
                let cloneLogList = clone.find('.lots-list--item-row--log-hidden');
                if (cloneLogList.length > 0) {
                    cloneLogList.remove();
                }
                let itemQty = parseInt(clone.find('.lots-list--item-row--column.quantity .edit-item').attr('data-amount'));
                qtyCount+= itemQty;
                let itemMinPrice = parseFloat(clone.find('.lots-list--item-row--column.min-price .edit-item').attr('data-amount'));
                minPriceCount+= itemMinPrice;
                let itemTargetPrice = parseFloat(clone.find('.lots-list--item-row--column.target-price .edit-item').attr('data-amount'));
                targetPriceCount+= itemTargetPrice;
                let itemBuyNow = parseFloat(clone.find('.lots-list--item-row--column.buy-now .edit-item').attr('data-amount'));
                buyNowCount+= itemBuyNow;
                let aiPrice = clone.find('.lots-list--item-row--column.ai-price .amount').html();
                let itemAiPrice = parseFloat( aiPrice.split(' ').join('') );
                aiPriceCount+= itemAiPrice;
                packItem.find('.lots-list--item-row--log-list').append(clone);
                countAppended++;
                packItem.find('.lots-list--item-row--log-list .lots-list--item-row').last().attr('data-order', (packItems.length + countAppended) -1);
            }
        });

        packItem.find('.lots-list--item-row--log-list .lots-item-checkbox').prop('checked', false);
        let newPackCount = packItem.find('.lots-list--item-row--log-list .lots-list--item-row');
        packItem.find('.image-wrap .count').html('+' + newPackCount.length);
        packItem.find('.lots-count').html('Lots: <span>' + newPackCount.length + '</span>');

        let orgQty = parseInt(packItem.find('.lots-list--item-row--column.quantity .edit-item').first().attr('data-amount'));
        packItem.find('.lots-list--item-row--column.quantity .edit-item').first().attr('data-amount', qtyCount + orgQty);
        packItem.find('.lots-list--item-row--column.quantity .amount').first().html(qtyCount + orgQty);
        let orgMinPrice = parseFloat(packItem.find('.lots-list--item-row--column.min-price .edit-item').first().attr('data-amount'));
        packItem.find('.lots-list--item-row--column.min-price .edit-item').first().attr('data-amount', minPriceCount + orgMinPrice);
        packItem.find('.lots-list--item-row--column.min-price .amount').first().html(minPriceCount + orgMinPrice);
        let orgTargetPrice = parseFloat(packItem.find('.lots-list--item-row--column.target-price .edit-item').first().attr('data-amount'));
        packItem.find('.lots-list--item-row--column.target-price .edit-item').first().attr('data-amount', targetPriceCount + orgTargetPrice);
        packItem.find('.lots-list--item-row--column.target-price .amount').first().html(targetPriceCount + orgTargetPrice);
        let orgBuyNow = parseFloat(packItem.find('.lots-list--item-row--column.buy-now .edit-item').first().attr('data-amount'));
        packItem.find('.lots-list--item-row--column.buy-now .edit-item').first().attr('data-amount', buyNowCount + orgBuyNow);
        packItem.find('.lots-list--item-row--column.buy-now .amount').first().html(buyNowCount + orgBuyNow);
        let orgAiPrice = parseFloat(packItem.find('.lots-list--item-row--column.ai-price .amount').first().html());
        packItem.find('.lots-list--item-row--column.ai-price .amount').first().html(aiPriceCount + orgAiPrice);

        self.resetCheckboxes();
    },
    resetCheckboxes() {
        $('.lots-item-checkbox').each(function (i, val) {
            $(val).prop('checked', false);
        });

        $('.check-all').prop('checked', false);
    },

    toggleLotsSidebar() {
        let sidebar = $('.lots-sidebar');
        let sidebarOver = $('.lots-sidebar-over');

        $('.auction-filter--added-count').on('click', function () {
            sidebarOver.fadeIn(300);
            sidebar.addClass('active');

            $('.column-type-drop a').eq(0).trigger('click');
            $('.lots-sidebar--heading .added span').html($('.lots-sidebar--inner > .lots-list--item-row').length);
        });

        $('.lots-sidebar-over, .lots-sidebar .close-sidebar').on('click', function () {
            sidebarOver.fadeOut(300);
            sidebar.removeClass('active');
        });
    },

    lotsSidebarDynamicColumnToggle() {
        let sidebarDropItems = $('.column-type-drop a');
        let sidebarHeadingItems = $('.column-type .text-wrap span');
        
       
        sidebarDropItems.on('click', function (e) {
            var dynamicItems = $('.lots-sidebar--inner .dynamic-column .lots-list--item-row--column');
            e.preventDefault();
            // drop
            let type = $(this).attr('data-type');
            sidebarDropItems.removeClass('active');
            $(this).addClass('active');

            // heading
            sidebarHeadingItems.removeClass('active');
            sidebarHeadingItems.each(function (i, val) {
                if ($(val).attr('data-type') === type) {
                    $(val).addClass('active');
                }
            });

            // dynamic column
            dynamicItems.removeClass('active');
            dynamicItems.each(function (i, val) {
                if ($(val).hasClass(type)) {
                    $(val).addClass('active');
                }
            });
        });
    },
    sidebarRemoveSingleItem() {
        // $('body').on('click', function (e) {
        //     if ($(e.target).hasClass('remove-from-sidebar')) {
        //         e.preventDefault();

        //         let sideBarCount = $('.lots-sidebar--heading .added span');
        //         $(e.target).parents().eq(3).remove();
        //         sideBarCount.html( parseInt(sideBarCount.html()) - 1 );
        //     }
        // });
    },
    sidebarRemoveAllItems() {
        // $('.remove-all-cart').on('click', function (e) {
        //     e.preventDefault();

        //     $('.lots-sidebar--inner').empty();
        //     $('.lots-sidebar--heading .added span').html(0);
        // });
    },
    lotsListAddSelected() {
        // let counter = $('.auction-filter--added-count .count');

        // $('body').on('click', function (e) {
        //     if ($(e.target).hasClass('add-lot-action')) {
        //         e.preventDefault();

        //         if (!$(e.target).parents().eq(3).hasClass('pack-item')) {
        //             counter.html(parseInt(counter.html()) + 1);
        //         } else {
        //             let packItem = $(e.target).parents().eq(3);
        //             let packCount = packItem.find('.lots-list--item-row--log-list>.lots-list--item-row').length;
        //             counter.html(parseInt(counter.html()) + packCount);
        //         }

        //         $.ajax({
        //             url: window.location.href,
        //             data: {
        //                 "page": currentPage,
        //                 "per_page": perPage,
        //                 "search" : searchedText,
        //                 "filters" : gatherFilters(false),
        //             },
        //             success: function(response) {
                      
        //                 $('#table-body-to-refresh').html(response['rows']);
        //                 $('#total-pages-count').html(response['pages']);
        //                 $('#detailed-filters-box').html(response['detailedFiltersHtml']);
        //                 reInitSelects();
        //                 highlightSearchedText(searchedText);
        //             }
        //         });

        //         // $(e.target).parents().eq(3).hide();
        //     }
        // });

        // $('.lots-list--controls--packing .add-selected').on('click', function (e) {
        //     e.preventDefault();

        //     let checkedListItems = $('.lots-list--body > .lots-list--item-row:not(:hidden) .lots-item-checkbox:checked');
        //     let countItems = 0;

        //     if (checkedListItems.length > 0) {
        //         checkedListItems.each(function (i, val) {
        //             if ($(val).parents().eq(3).hasClass('pack-item')) {
        //                 let packItem = $(val).parents().eq(3);
        //                 let packCount = packItem.find('.lots-list--item-row--log-list>.lots-list--item-row').length;
        //                 countItems+= packCount;
        //             } else {
        //                 countItems++;
        //             }

        //             // $(val).parents().eq(3).hide();
        //         });
        //         counter.html(parseInt(counter.html()) + countItems);
        //     }
        // });
    },
    quickView() {
        const self = this;
        let quickView = $('.quick-view-box');
        let slickSettings = {
            slidesToShow: 1,
            dots: false,
            infinite: false,
            arrows: true,
            speed: 300,
            autoplay: false,
            slidesToScroll: 1,
            fade: true,
            // responsive: [
            //     {
            //         breakpoint: 1200,
            //         settings: {
            //             slidesToShow: 2,
            //         }
            //     }
            // ]
        };
        let slider = $('.quick-view-box--gallery--main-slider');
        let body = $('body');

        body.on('click', function (e) {
            if ($(e.target).hasClass('quick-view')) {
                e.preventDefault();

                quickView.fadeIn(300);
                slider.slick(slickSettings);
                self.fancyboxSettings();
                self.galleryNavigation();
            }
        });

        $('.quick-view-box--inner .close').on('click', function () {
            quickView.fadeOut(300);
            setTimeout(function () {
                slider.slick('unslick');
            }, 500);
        });

        body.on('mousedown', function (e) {
            if ($(e.target).hasClass('quick-view-box')) {
                quickView.fadeOut(300);
                setTimeout(function () {
                    slider.slick('unslick');
                }, 500);
            }
        });
    },
    fancyboxSettings() {
        let selector = $('.quick-view-box--gallery--main-slider .slick-slide a');

        selector.fancybox({
            loop: false,
            infobar: false,
            hash: false,
            backFocus: false,
            animationEffect: "fade",
            padding: 0,
            thumbs: {
                autoStart: false
            },
            buttons: [
                'slideShow',
                'fullScreen',
                'close'
            ]
        });
    },
    galleryNavigation() {
        let navItems = $('.quick-view-box--gallery--navigation .item');
        let galleryItems = $('.quick-view-box--gallery--main-slider .slick-slide');
        let fancyboxItems = $('.quick-view-box--gallery--main-slider .slick-slide a');
        let slider = $('.quick-view-box--gallery--main-slider');

        navItems.eq(0).addClass('active');

        // counter
        if (galleryItems.length > navItems.length) {
            $('.quick-view-box--gallery--navigation .item.counter span').html( '+' + (galleryItems.length -11).toString());
        } else {
            $('.quick-view-box--gallery--navigation .item.counter').remove();
        }

        // navigation click
        navItems.on('click', function () {
            let thisIndex = $(this).index();

            fancyboxItems.eq(thisIndex).trigger('click');
            navItems.removeClass('active');
            navItems.eq(thisIndex).addClass('active');
            slider.slick('slickGoTo', thisIndex);
        });

        // slider change
        slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            navItems.removeClass('active');
            navItems.eq(nextSlide).addClass('active');

            if (nextSlide + 1 === 12) {
                fancyboxItems.eq(nextSlide).trigger('click');
            }
        });
    },
    // quickViewHistoryToggle() {
    //     $('body').on('click', function (e) {
    //         if ($(e.target).hasClass('quick-view-history-toggle')) {
    //             let historyBox = $('.quick-view-box--history .lots-list--item-row--log-list');
    //             historyBox.slideToggle(300);
    //             $('.quick-view-history-toggle').toggleClass('hidden');
    //         }
    //     });
    // },
}